import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

// The old Attendance and Time Management pages now live in Time &
// Attendance; their URLs (bookmarks, links in notification emails such as
// /attendance?employee_id=7) keep working for a while by redirecting.

/** /attendance -> the Week tab, or the Employee tab with ?employee_id=. */
export const AttendanceRedirect = () => {
  const [params] = useSearchParams();
  const employeeId = params.get('employee_id');
  const to = employeeId && /^\d+$/.test(employeeId)
    ? `/time-attendance?tab=employee&employee=${employeeId}`
    : '/time-attendance?tab=week';
  return <Navigate to={to} replace />;
};

/** /time-management (clock in/out, attendance, leave) -> the Today tab. */
export const TimeManagementRedirect = () => <Navigate to="/time-attendance" replace />;
